import React from "react";
import PropTypes from "prop-types";

import { toast } from "react-toastify";
import { AppContext } from "components";
import { ProductController } from "controllers";
import { BaseComponent } from "shared/components";
import "react-toastify/dist/ReactToastify.css";

import {
    ItemFamilySelect, WashingSelect, CutSelect,
    SizeSelect, ColorSelect, BrandSelect, AttributeSelect,
    SupplierSelect, CategoriesSelect, TagsSelect, ImagesUpload, DetailsSelect
} from "components/ProductComponents";

import * as helper from "./helper";
import { CustomerSearchInput } from "shared/components/customers/misc/customer-search-input";
import { v4 as uuidv4 } from 'uuid';


class ProductCreateContainer extends BaseComponent {
    constructor(props) {
        super(props);

        this.imagesUploadRef = React.createRef();

        this.state = {
            barcode: "",
            color: [],
            attributes: [],
            category: "",
            tags: [],
            details: [],
            cuts: [],
            supplier: "",
            name: "",
            size: "",
            uid:uuidv4(),
            description: "",
            typeofgarment: "",
            mintcondition: "",
            buyingprice: "",
            targetsalesprice: "",
            finalsalesprice: "",
            currency: "USD",
            washingdetergent: [],
            gender: '',
            materialdata: {materials: [],selectedMaterial: ''},
            yearofproduction: "",
            sold: false,
            platformsold: '',
            beforewash:{front:[], back:[]},
            afterwash:{front:[], back:[]},
            brand: "",
            season: "All Year",
            washing: '30 Dark Colours',
            itemFamily: "Basic",
            userSelected: '',
            file: [],
            users: [],
            isModalVisible: false,
            appPreview: false,
        };

        this.onChange = this.onChange.bind(this);
        this.createProduct = this.createProduct.bind(this);
        this.onChangeImages = this.onChangeImages.bind(this);
        this.onChangeImagesBF = this.onChangeImagesBF.bind(this);
        this.setState = this.setState.bind(this);
        this.onChangeImagesBB = this.onChangeImagesBB.bind(this);
        this.onChangeImagesAF = this.onChangeImagesAF.bind(this);
        this.onChangeImagesAB = this.onChangeImagesAB.bind(this);
        this.onChangeCheckbox = this.onChangeCheckbox.bind(this);

        this.resetState = this.resetState.bind(this);
    }

    componentDidMount = async () => {
        toast.configure({
            autoClose: 2000,
            draggable: false
        });
    };

    onChange(event) {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    onChangeImages(images) {
        this.setState({
            file: images.file,
        });
    }
    onChangeImagesBF(images) {
       
        this.setState(prevState => ({
            beforewash: {
              ...prevState["beforewash"],
                front: images.file,
            },
          }));
    }
    onChangeImagesBB(images) {
        this.setState(prevState => ({
            beforewash: {
              ...prevState["beforewash"],
                back: images.file,
            },
          }));
    }
    onChangeImagesAF(images) {
        this.setState(prevState => ({
            afterwash: {
              ...prevState["afterwash"],
                front: images.file,
            },
          }));
    }
    onChangeImagesAB(images) {
        this.setState(prevState => ({
            afterwash: {
              ...prevState["afterwash"],
                back: images.file,
            },
          }));
    }

    onChangeCheckbox(event) {

        const { name } = event.currentTarget;
        const checkboxValue = this.state[name];
        if (name === "sold" ) {
            this.setState({ sold: !this.state.sold });
        } else {
            this.setState({ [name]: !checkboxValue });
    }
    }

    handleModalDisagree = () => {
        this.setState({ isModalVisible: false });
    }

    handleModalAgree = async () => {
        const {
            barcode,
            color,
            attributes,
            category,
            tags,
            cuts,
            supplier,
            details,
            uid,
            name,
            size,
            brand,
            season,
            washing,
            itemFamily,
            targetsalesprice,
            finalsalesprice,
            file,
            description,
            typeofgarment,
            mintcondition,
            buyingprice,
            currency,
            washingdetergent,
            gender,
            materialdata,
            yearofproduction,
            sold,
            platformsold,
            beforewash,
            afterwash,
            userSelected
        } = this.state;

        this.setState({ isModalVisible: false });

        const excluded_customer = userSelected ? userSelected : "";

        let beforewashImagesURL = {};
        let afterwashImagesURL = {};
        await this.context.showLoading();
        
        if (beforewash.front && beforewash.front.length > 0) {
            file.url = await helper.handleUpload(beforewash.front[0], barcode);
            beforewashImagesURL["frontUrl"]=file.url 
        }
        if (beforewash.back && beforewash.back.length > 0) {
            file.url = await helper.handleUpload(beforewash.back[0], barcode);
            beforewashImagesURL["backUrl"]=file.url 
        }
        if (afterwash.front && afterwash.front.length > 0) {
            file.url = await helper.handleUpload(afterwash.front[0], barcode);
            afterwashImagesURL["frontUrl"]=file.url 
        }
        if (afterwash.back && afterwash.back.length > 0) {
            file.url = await helper.handleUpload(afterwash.back[0], barcode);
            afterwashImagesURL["backUrl"]=file.url 
        }

       

        const location = helper.generateLocationCode(size, category);

        if (barcode !== "") {
            const payload = {
                barcode,
                color,
                attributes,
                category,
                tags,
                cuts,
                uid,
                supplier,
                details,
                name,
                size,
                brand,
                location,
                targetsalesprice,
                finalsalesprice,
                season,
                washing,
                item_family: itemFamily,
                excluded_customer,
                description,
                typeofgarment,
                mintcondition,
                buyingprice,
                currency,
                washingdetergent,
                gender,
                materialdata,
                yearofproduction,
                sold,
                platformsold,
                beforewashImagesURL,
                afterwashImagesURL,
                status: "available",
                cycles: 0,
                market: this.country,
                is_preview: this.state.appPreview
            };

            try {
                await ProductController.create(payload);
                await this.context.hideLoading();

                this.resetState();
                toast.success("Product upload successfully.", {
                    position: toast.POSITION.TOP_LEFT
                });

                window.scrollTo(0, 0);
            } catch (e) {
                await this.context.hideLoading();
                toast.error(e.message, {
                    position: toast.POSITION.TOP_LEFT
                });
            }
        }
    }

    resetState = () => {
        this.setState({
            barcode: "",
            color: [],
            attributes: [],
            name: "",
            category: "",
            tags: [],
            details: [],
            cuts: [],
            uid:uuidv4(),
            description: "",
            typeofgarment: "",
            mintcondition: "",
            washingdetergent: [],
            buyingprice: "",
            currency: "USD",
            gender: "",
            materialdata: {materials: [],selectedMaterial: ''},
            yearofproduction: 2024,
            sold: false,
            targetsalesprice:"",
            finalsalesprice:"",
            platformsold: '',
            beforewash:{front:[], back:[]},
            afterwash:{front:[], back:[]},
            brand: "",
            season: "All Year",
            washing: '30 Dark Colours',
            itemFamily: "Basic",
            userSelected: '',
            appPreview: false
        });

        this.imagesUploadRef.current.resetState();
        this.imagesUploadRef1.current.resetState();
        this.imagesUploadRef2.current.resetState();
        this.imagesUploadRef3.current.resetState();
    };

    async createProduct(e) {
        e.preventDefault();
        const { barcode } = this.state;

        try {
            helper.verifyRequiredFields(this.state);
            await helper.verifyBarcode(barcode);
            
        } catch (error) {
            toast.warn(error.message, { position: toast.POSITION.TOP_LEFT });
            return;
        }

        // if (file.length === 0) {
        //     toast.warn("Please upload one image.", {
        //         position: toast.POSITION.TOP_LEFT
        //     });
        //     return;
        // }

        this.setState({ isModalVisible: true });
    }

    render() {
        return (
            <React.Fragment>
                <div className="columns is-gapless">

                    <div className="column is-1 is-hidden-mobile">
                        <section className="hero is-fullheight hero-products-pattern">
                            <div className="hero-body"></div>
                        </section>
                    </div>

                    <div className="column">
                        <div className="container mt-4 pt-4">
                            <form noValidate>
                                {/* FIRST SECTION */}
                                <div className="columns">
                                    <div className="column px-6 is-6">
                                        <div className="field">
                                            <label className="label">Barcode</label>
                                            <div className="control">
                                                <input
                                                    className="input"
                                                    name="barcode"
                                                    type="text"
                                                    value={this.state.barcode}
                                                    onChange={this.onChange}
                                                    placeholder="XXXXXXXX" />
                                            </div>
                                        </div>

                                        <CategoriesSelect name="category" value={this.state.category} label="Category" onChange={this.onChange} />
                                        <ColorSelect name="color" value={this.state.color} label="Colors" id="color-select" onChange={this.onChange} />
                                        <AttributeSelect name="attributes" value={this.state.attributes} label="Attributes" id="attribute-select" onChange={this.onChange} />
                                        <TagsSelect name="tags" id="tag-select" value={this.state.tags} placeholder="Tags" label="Tags" onChange={this.onChange} />
                                        <DetailsSelect name="details" id="details-select" value={this.state.details} placeholder="Details" label="Details" onChange={this.onChange} />
                                        <CutSelect category={this.state.category} name="cuts" id="cut-select" value={this.state.cuts} label="Cuts" onChange={this.onChange} />

                                        <ImagesUpload size="is-small" ref={this.imagesUploadRef} onChange={this.onChangeImages} />
                                    </div>
                                    <div className="column px-6 is-6">
                                        <SupplierSelect name="supplier" value={this.state.supplier} id="supplier-select" label="Supplier" onChange={this.onChange} />

                                        <div className="field">
                                            <label className="label">Name</label>
                                            <div className="control">
                                                <input
                                                    className="input"
                                                    name="name"
                                                    type="text"
                                                    value={this.state.name}
                                                    onChange={this.onChange}
                                                    placeholder="Name" />
                                            </div>
                                        </div>

                                        <SizeSelect name="size" value={this.state.size} id="size-select" label="Size" onChange={this.onChange} />
                                        <BrandSelect name="brand" value={this.state.brand} id="brand-select" label="Brand" onChange={this.onChange} />
                                        <WashingSelect name="washing" value={this.state.washing} id="washing-select" label="Washing" onChange={this.onChange} />
                                        <CustomerSearchInput
                                            name="userSelected" placeholder="Type customer's name"
                                            value={this.state.userSelected}
                                            id="customer-search" label="Excluded Customer" onChange={this.onChange} />

                                        <ItemFamilySelect name="itemFamily" value={this.state.itemFamily} label="Item Family" id="item-family" onChange={this.onChange} />
                                    </div>
                                    <div className="column">

                                    </div>
                                </div>
                                {/* END SECTION */}


                                <div className="field is-grouped">
                                    <div className="control">
                                        <button
                                            name="submit"
                                            type="button"
                                            className="button is-primary"
                                            onClick={this.createProduct}>Submit</button>
                                    </div>
                                    <div className="control">
                                        <button type="button"
                                            name="reset"
                                            className="button is-primary is-light"
                                            onClick={this.resetState}>Reset</button>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>

                {/* CONFIRMATION MODAL  */}
                <div className={`modal ${this.state.isModalVisible ? 'is-active' : ''}`}>
                    <div className="modal-background"></div>
                    <div className="modal-card">
                        <header className="modal-card-head">
                            <p className="modal-card-title">Confirmation</p>
                            <button className="delete" aria-label="close"></button>
                        </header>
                        <section className="modal-card-body">
                            <p>Are you sure to import these products?</p>
                        </section>
                        <footer className="modal-card-foot">
                            <button type="button" className="button is-primary" onClick={this.handleModalAgree}>Yes</button>
                            <button type="button" className="button" onClick={this.handleModalDisagree}>No</button>
                        </footer>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

ProductCreateContainer.contextType = AppContext;

ProductCreateContainer.propTypes = {
    history: PropTypes.object
};

export default ProductCreateContainer;
